import { useContext } from "react"
import { TurnstileContext } from "./turnstile-provider"

export const useTurnstile = () => useContext(TurnstileContext)
